import directory from '@/api/adminDirectory';

function toError(e) {
    return {
        status: e?.response?.status || 0,
        message: e?.response?.data?.message || ''
    };
}

export const state = {
    directory: directory('admin'),
    usage: [],
    usageLoading: false,
    usageError: null,
    events: [],
    eventsLoading: false,
    eventsError: null
};

export const getters = {
    usage: function (state) {
        return state.usage;
    },
    usageLoading: function (state) {
        return !!state.usageLoading;
    },
    usageError: function (state) {
        return state.usageError;
    },
    events: function (state) {
        return state.events;
    },
    eventsLoading: function (state) {
        return !!state.eventsLoading;
    },
    eventsError: function (state) {
        return state.eventsError;
    }
};

export const mutations = {
    'SET_USAGE': function (state, usage = []) {
        state.usage = usage;
    },
    'SET_USAGE_LOADING': function (state, boolean = true) {
        state.usageLoading = boolean;
    },
    'SET_USAGE_ERROR': function (state, error = null) {
        state.usageError = error;
    },
    'SET_EVENTS': function (state, events = []) {
        state.events = events;
    },
    'SET_EVENTS_LOADING': function (state, boolean = true) {
        state.eventsLoading = boolean;
    },
    'SET_EVENTS_ERROR': function (state, error = null) {
        state.eventsError = error;
    }
};

export const actions = {
    usage: function ({commit, state}, {componentId, versionIds}) {
        commit('SET_USAGE_LOADING', true);
        commit('SET_USAGE_ERROR', null);

        const ids = versionIds || [];

        return state.directory.fetchTemplates({per_page: 100}).then(response => {
            const templates = response?.data || [];

            // Batches of four: the named rate limiter would refuse one request per template.
            const details = [];

            return templates.reduce((chain, template, index) => {
                if (index % 4) {
                    return chain;
                }

                return chain.then(() => {
                    return Promise.all(templates.slice(index, index + 4).map(item => {
                        return state.directory.fetchTemplate(item.id).then(detail => {
                            return detail?.data || null;
                        }).catch(() => {
                            return null;
                        });
                    }));
                }).then(batch => {
                    details.push(...batch);
                });
            }, Promise.resolve()).then(() => details);
        }).then(details => {
            const usage = [];

            (details || []).forEach(template => {
                if (!template) {
                    return;
                }

                const matches = (template.components || []).filter(entry => {
                    if (ids.length) {
                        return ids.includes(entry.component_version_id);
                    }

                    return entry.component_version
                        && entry.component_version.component_id === componentId;
                });

                if (!matches.length) {
                    return;
                }

                usage.push({
                    id: template.id,
                    name: template.name,
                    status: template.status,
                    type: template.type,
                    versions: matches.map(entry => {
                        return entry.component_version ? entry.component_version.version_number : null;
                    }).filter(value => value !== null),
                    optional: matches.every(entry => entry.is_optional)
                });
            });

            commit('SET_USAGE', usage);
            commit('SET_USAGE_LOADING', false);

            return usage;
        }).catch(e => {
            commit('SET_USAGE_ERROR', toError(e));
            commit('SET_USAGE_LOADING', false);

            return [];
        });
    },

    events: function ({commit, state}, entityId) {
        commit('SET_EVENTS_LOADING', true);
        commit('SET_EVENTS_ERROR', null);

        return state.directory.fetchAuditEvents({entity_id: entityId, per_page: 50}).then(response => {
            commit('SET_EVENTS', response?.data || []);
            commit('SET_EVENTS_LOADING', false);

            return response?.data || [];
        }).catch(e => {
            commit('SET_EVENTS_ERROR', toError(e));
            commit('SET_EVENTS_LOADING', false);

            return [];
        });
    },

    clear: function ({commit}) {
        commit('SET_USAGE', []);
        commit('SET_USAGE_ERROR', null);
        commit('SET_EVENTS', []);
        commit('SET_EVENTS_ERROR', null);
    }
};
